import React from "react";
import type { TaxBreakdown } from "@b2bportal/air-booking-api";
import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import {
  Dialog,
  DialogContent,
  DialogClose,
  Icon,
  DialogTrigger,
  Button,
} from "@tenant/ui";
import styles from "./TaxBreakdownModal.module.scss";

interface TaxBreakdownModalProps {
  taxBreakdown: TaxBreakdown;
}

export const TaxBreakdownModal = ({ taxBreakdown }: TaxBreakdownModalProps) => {
  const { formatFiatCurrency, t } = useI18nContext();
  const [, cn] = useModuleBEM(styles, "TaxBreakdownModal");

  return (
    <Dialog modal>
      <DialogTrigger className={cn("trigger")} asChild>
        <button
          type="button"
          aria-label={t("core-flights.taxBreakdown.viewButtonAriaLabel")}
        >
          <Icon
            className={cn("trigger-icon")}
            iconName={IconNameEnum.ui__infoPopover}
          />
        </button>
      </DialogTrigger>
      <DialogContent
        className={cn("tax-dialog")}
        title={t("core-flights.taxBreakdown.modalTitle")}
        bottomFixedContent={
          <DialogClose asChild>
            {/* eslint-disable-next-line @typescript-eslint/no-empty-function */}
            <Button onClick={() => {}} className={cn("close-button")}>
              {t("core-flights.taxBreakdown.closeButton")}
            </Button>
          </DialogClose>
        }
      >
        <div className={cn("tax-dialog-body")}>
          {taxBreakdown.taxLineItems.length > 0 ? (
            taxBreakdown.taxLineItems.map((item) => (
              <div
                key={item.code || `${item.description}-${item.amount.fiat}`}
                className={cn("tax-line")}
              >
                <div className={cn("tax-label")}>
                  {item.description ||
                    item.code ||
                    t("core-flights.taxBreakdown.defaultTaxLabel")}
                  {item.code && item.description && (
                    <span className={cn("tax-code")}> ({item.code})</span>
                  )}
                </div>
                <div className={cn("tax-amount")}>
                  {formatFiatCurrency(item.amount.fiat)}
                </div>
              </div>
            ))
          ) : (
            <p>{t("core-flights.taxBreakdown.noTaxesAvailable")}</p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
